import {
  ADD_NOTIFICATION_GROUP,
  REMOVE_NOTIFICATION_GROUP,
  GET_NOTIFICATION_GROUP,
  GET_NOTIFICATION_GROUPS,
  GET_NOTIFICATION_GROUP_MEMBERS,
  UPDATE_NOTIFICATION_GROUP_MEMBERS,
  UPDATE_NOTIFICATION,
  SEND_NOTIFICATION,
  GET_NOTIFICATIONS,
  GET_NEW_NOTIFICATIONS_COUNT,
  SET_NOTIFICATION_CONTEXT,
  ADD_NEW_NOTIFICATION_TO_CONTEXT,
  SET_SCHEDULE_NOTIFICATIONS,
  ADD_NEW_SCHEDULE_NOTIFICATION,
  NOTIFICATION_CONTEXT_SET_NEW_COUNT
} from './../types/notificationConstants'

export function addNotificationGroup(item) {
  return {
    type: ADD_NOTIFICATION_GROUP,
    payload: item
  }
}

export function removeNotificationGroup(item) {
  return {
    type: REMOVE_NOTIFICATION_GROUP,
    payload: item
  }
}

export function getNotificationGroup(id) {
  return {
    type: GET_NOTIFICATION_GROUP,
    payload: id
  }
}

export function getNotificationGroups() {
  return {
    type: GET_NOTIFICATION_GROUPS
  }
}

export function sendNotification(item) {
  return {
    type: SEND_NOTIFICATION,
    payload: item
  }
}

export function updateNotification(item) {
  return {
    type: UPDATE_NOTIFICATION,
    payload: item
  }
}

export function getNotifications(id) {
  return {
    type: GET_NOTIFICATIONS
  }
}

export function getNewNotificationCount(id) {
  return {
    type: GET_NEW_NOTIFICATIONS_COUNT
  }
}

export function getNotificationGroupMembers(id) {
  return {
    type: GET_NOTIFICATION_GROUP_MEMBERS
  }
}

export function updateNotificationGroupMembers(request) {
  return {
    type: UPDATE_NOTIFICATION_GROUP_MEMBERS,
    payload: request
  }
}

export function setNotificationContext(notificationContext) {
  return {
    type: SET_NOTIFICATION_CONTEXT,
    payload: notificationContext
  }
}

export function addNewNotificationToContext(notification) {
  return {
    type: ADD_NEW_NOTIFICATION_TO_CONTEXT,
    payload: notification
  }
}

export function setScheduleNotifications(scheduleNotificationContext) {
  return {
    type: SET_SCHEDULE_NOTIFICATIONS,
    payload: scheduleNotificationContext
  }
}

export function addNewScheduleNotification(notification) {
  return {
    type: ADD_NEW_SCHEDULE_NOTIFICATION,
    payload: notification
  }
}

export function notificationContextSetNewCount(count) {
  return {
    type: NOTIFICATION_CONTEXT_SET_NEW_COUNT,
    payload: count
  }
}
